import { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as apiClient from 'api/apiClients';
import { useToast } from 'context/ToastContext';
import ESpinner from '../../others/Spinner';
import ClientInfoForm from './ClientInfoForm';
import ClientInfoMap from './ClientInfoMap';

interface OffClientInfoProps {
    clientId: number | null;
    setClientId: (clientId: number | null) => void;
}

const OffClientInfo = ({ clientId, setClientId }: OffClientInfoProps) => {
    const { t } = useTranslation(['Clients', 'common']);
    const { showToast } = useToast();
    const [client, setClient] = useState<any>(null);

    const fetchClient = async () => {
        if (!clientId) return;
        const resClient = await apiClient.getClientById(clientId);
        if (!resClient) {
            showToast(t('common:messError'), 'danger');
            return;
        }
        setClient(resClient);
    };

    const handleClose = () => {
        setClientId(null);
    };

    useEffect(() => {
        if (clientId) fetchClient();
        else {
            setTimeout(() => {
                setClient(null);
            }, 300);
        }
    }, [clientId]);

    return (
        <Offcanvas show={clientId !== null} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('titleInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {client ? (
                    <>
                        <ClientInfoForm setClient={setClient} fetchClient={fetchClient} client={client} />
                        <ClientInfoMap
                            clientAddress={client.clientAddress}
                            clientLocationUrl={client.clientLocationUrl}
                        />
                    </>
                ) : (
                    <ESpinner />
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffClientInfo;
